import { InvalidateQueryFilters, useQuery, useQueryClient } from '@tanstack/react-query'
import { getOrganizations, removeUserAndOrganization } from 'api/account'
import { useState } from 'react'
import { Organization } from 'types/Organization'
import { TableConfig } from 'types/TableHeader'

export const useOrganizations = () => {
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedOrganization, setSelectedOrganization] = useState<Organization | null>(null)
    const [isDialogVisible, setIsDialogVisible] = useState(false)
    const queryClient = useQueryClient()

    const handleSearch = (value: string) => {
        setSearchTerm(value)
        queryClient.invalidateQueries(['organizations'] as InvalidateQueryFilters)
    }

    const handleEdit = (rowData: Organization) => {
        setSelectedOrganization(rowData)
        handleOpenDialog()
    }

    const handleDelete = async (orgId: string) => {
        try {
            await removeUserAndOrganization(orgId)
            queryClient.invalidateQueries(['organizations'] as InvalidateQueryFilters)
        } catch (error) {
            console.error('Error deleting organization:', error)
        }
    }

    const handleOpenDialog = () => {
        setIsDialogVisible(true)
    }

    const handleCloseDialog = () => {
        setSelectedOrganization(null)
        setIsDialogVisible(false)
    }

    const tableConfig: TableConfig = {
        titleRow: {
            title: 'Szervezetek',
            buttonLabel: 'Szervezet felvétele',
            formConfig: {
                dialogProps: {
                    header: 'Szervezet felvétele',
                },
            },
        },
        headers: [
            { field: 'name', title: 'Szervezet neve', sortable: true },
            { field: 'email', title: 'Email cím', sortable: true },
            { field: 'contact_info', title: 'Elérhetőség', sortable: true },
            { field: 'not_payed_income', title: 'Ki nem fizetett bevétel' },
            { field: 'not_payed_shows', title: 'Ki nem fizetett előadások' },
        ],
        idName: 'org_id',
    }

    const { data, isLoading, error } = useQuery({
        queryKey: ['organizations', searchTerm],
        queryFn: () => getOrganizations(searchTerm),
    })

    return {
        data,
        isLoading,
        error,
        tableConfig,
        handleEdit,
        handleDelete,
        handleSearch,
        handleOpenDialog,
        handleCloseDialog,
        isDialogVisible,
        selectedOrganization,
    }
}
